import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { RolePermissionStaff } from "./RolePermissionStaff";
import type { ScopesDTOBase } from "./ScopesDTOBase";
import type { UserPermissionStaff } from "./UserPermissionStaff";

export class ScopesStaff implements ScopesDTOBase {
  constructor(public readonly scopeId: string, public readonly description: string | null, public readonly rolePermissions: Array<RolePermissionStaff> | null, public readonly userPermissions: Array<UserPermissionStaff> | null) {
    this.cbiServiceContext = null;
    this.rolePermissionsLoaded = this.rolePermissions != null;
    this.rolePermissionsCached = this.rolePermissions;
    this.userPermissionsLoaded = this.userPermissions != null;
    this.userPermissionsCached = this.userPermissions;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private rolePermissionsLoaded: boolean;
  private rolePermissionsCached: Array<RolePermissionStaff> | null;
  private userPermissionsLoaded: boolean;
  private userPermissionsCached: Array<UserPermissionStaff> | null;
  async rolePermissionsLazy(): Promise<Array<RolePermissionStaff>> {
    if (!this.rolePermissionsLoaded) {
      this.rolePermissionsCached = await this.cbiServiceContext!.permissionService().getScopesStaffRolePermissions(this.scopeId);
      this.rolePermissionsLoaded = true;
    }
    return this.rolePermissionsCached!;
  }
  async userPermissionsLazy(): Promise<Array<UserPermissionStaff>> {
    if (!this.userPermissionsLoaded) {
      this.userPermissionsCached = await this.cbiServiceContext!.permissionService().getScopesStaffUserPermissions(this.scopeId);
      this.userPermissionsLoaded = true;
    }
    return this.userPermissionsCached!;
  }
}
